/** Modos HVAC UI SHC (paridad Samsung); ThinQ se normaliza en backend. */

export const AC_MODES_UI = ['auto', 'cool', 'heat', 'fan', 'dry'] as const;
export const FAN_MODES_UI = ['auto', 'low', 'medium', 'high'] as const;

export function displayHvacMode(mode: string | null | undefined): string {
  if (!mode) return '—';
  const m = String(mode).toLowerCase();
  if (m === 'wind') return 'fan';
  return m;
}

export function uiHvacModeValue(mode: string | null | undefined): string {
  return displayHvacMode(mode) === '—' ? '' : displayHvacMode(mode);
}

/** Valor a enviar al API LG (backend mapea a ThinQ). */
export function stHvacModeValue(uiMode: string): string {
  const m = String(uiMode).toLowerCase();
  if (m === 'wind') return 'fan';
  return m;
}

/** LG: en seco (AIR_DRY) el ventilador sigue eligiendo velocidad (a diferencia de Samsung). */
export function availableFanModes(_hvacMode: string | null | undefined): readonly string[] {
  return FAN_MODES_UI;
}
